import React, { useEffect, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DoneIcon from "@mui/icons-material/Done";
import { Cancel, CancelOutlined, Edit } from "@mui/icons-material";
import addpdforange from "../../assets/tasks/material-symbols-light_note-add-sharp.svg";
import CloseIcon from "@mui/icons-material/Close";
import Addnote from "../Modals/Addnote";
import dayjs from "dayjs";
import addpdf from "../../assets/tasks/addicon.svg";
import Updatenote from "../Modals/Updatenote";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import api from "../../api/api";
import ScheduleModal from "../Modals/ScheduleModal";
import DoctorF from "../../assets/tasks/DoctorP.svg";
import Alertsgraphs from "../Modals/Alertsgraphs";

import { useSelector } from "react-redux";
import {
  cancelIcon,
  completedIcon,
  eyeIcon,
  fileIcon,
  flag,
  userIcon,
} from "../svgs";
import { COMPLETEDIcon, CROSSIcon } from "../../landingscreen/modals/svgs";
import ConfirmDialog from "../Modals/ConfirmDialog";
const FullViewCard = ({
  task,
  markAsFlag,
  markAsComplete,
  markAscancel,
  handleconfirmScheduleClick,
  scheduleStates,
  trigger,
  selectedOrder,
  setSelectedOrder,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [scheduleConfirmationOpen, setScheduleConfirmationOpen] =
    useState(false);
  // const [selectedOrder, setSelectedOrder] = useState(null);
  const [showAllOrders, setShowAllOrders] = useState(false);
  // const [isCompletedOrCancelled, setIsCompletedOrCancelled] = useState(false);
const practiseid = window.getPracticeId();
  const [completedOrders, setCompletedOrders] = useState({});
  const userConfig = useSelector((state) => state.userconfig);
  const [isAlertModal, setIsAlertModal] = useState(false);
  const [flagOption, setFlagOption] = useState(false);
  const [selectedAlert, setSelectedAlert] = useState(null);
  const taskscreenprev = useSelector((state) => state.userPrivileges.taskrpm);
  const [confirmState, setConfirmState] = useState({
    open: false,
    type: null, // "complete" | "cancel"
    order: null,
  });

  const handleCompleteClick = (order) => {
    // open confirm dialog instead of acting immediately
    setConfirmState({ open: true, type: "complete", order });
  };

  const handleCancelClick = (order) => {
    // open confirm dialog instead of acting immediately
    setConfirmState({ open: true, type: "cancel", order });
  };

  const handleAlertOpenModal = (order) => {
    setSelectedAlert(order); // Store the selected patient ID
    setIsAlertModal(true); // Open the modal
  };
  const handleAlertCloseModal = () => {
    setIsAlertModal(false); // Close the modal
  };
  const updateResult = async (order, value) => {
  try {
    // optimistic update
    order.result = value;

    await api.put(`/v1/${practiseid}/orders/${task.patientid}/update-result`, {
      id: order.id,
      result: value,
      orderdate: dayjs(order.ts).format("YYYY-MM-DD"),
    });

    trigger(); // refresh parent list
  } catch (e) {
    console.log("result update failed", e);
  }
};
  // Function to open the modal
  const openModal = (order) => {
    setSelectedOrder(order); // Set the selected order dynamically
    if (order.order_notes) {
      setModalType("update");
    } else {
      setModalType("add");
    }
    setIsModalOpen(true);
  };
  let user = localStorage.getItem("user");

  const runConfirmAction = () => {
    const { type, order } = confirmState;
    if (!order) return;

    if (type === "complete") {
      markAsComplete([order.id.toString()], order);
      setCompletedOrders((prev) => ({ ...prev, [order.id]: "completed" }));
    } else if (type === "cancel") {
      markAscancel([order.id.toString()], order);
      setCompletedOrders((prev) => ({ ...prev, [order.id]: "cancelled" }));
    }

    setConfirmState({ open: false, type: null, order: null });
  };

  const closeConfirm = () =>
    setConfirmState({ open: false, type: null, order: null });

  // const handleCompleteClick = (order) => {
  //   markAsComplete([order.id.toString()], order);
  //   // setIsCompletedOrCancelled(order); // Step 2: Update the state when a button is clicked
  //   setCompletedOrders((prevState) => ({
  //     ...prevState,
  //     [order.id]: "completed",
  //   }));
  // };

  // const handleCancelClick = (order) => {
  //   markAscancel([order.id.toString()], order);
  //   // setIsCompletedOrCancelled(order); // Step 2: Update the state when a button is clicked
  //   setCompletedOrders((prevState) => ({
  //     ...prevState,
  //     [order.id]: "cancelled",
  //   }));
  // };

  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
    setScheduleConfirmationOpen(order); // Open the confirmation modal
  };

  // Function to close the modal
  const closeModal = () => setIsModalOpen(false);

  const closeScheduleConfirmationModal = () => {
    setScheduleConfirmationOpen(false);
    setSelectedOrder(null);
  };

  const percentage = 100; // Set your percentage value here

  // Styles for the circular progress bar and small circle with percentage text
  const circleStyle = {
    background: `conic-gradient(#E17954B2 ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };

  const angle = percentage * 3.6;
  const getOrderStatusColor = (status) => {
    switch (status) {
      case "CANCELLED":
        return "bg-red-500";
      case "INFO":
        return "bg-blue-500";
      case "CREATED":
        return "bg-[#E17954]";
      case "COMPLETED":
        return "bg-green-500";
      default:
        return "bg-red-500";
    }
  };

  const toggleShowAllOrders = () => {
    setShowAllOrders((prev) => !prev); // Toggle show/hide all orders
  };
  const normalise = (type) => {
    return type === "procedure" ? "procedures" : type;
  };
  const visibleOrders = task.orders.filter((order) => {
    const type = order.ordertype.toLowerCase();
    return !(
      (type === "labs" || type === "schedule-rto" || type === "procedure") &&
      !taskscreenprev.some((item) => item.toLowerCase() === normalise(type))
    );
  });

  const totalCount = visibleOrders.length;
  const createdCount = visibleOrders.filter(
    (o) => String(o?.status).toUpperCase() === "CREATED"
  ).length;
  const allCompleted =
    totalCount > 0 &&
    visibleOrders.every((o) => String(o?.status).toUpperCase() === "COMPLETED");

  // what to show in the pill
  const pillCount = allCompleted ? totalCount : createdCount;
  // pill color: grey when all done, orange when still have "CREATED"
  const pillBg = allCompleted ? "bg-[#99A1AF]" : "bg-[#E17954]";

  return (
    <div key={task.id} className="w-full min-h-[150px] h-auto mb-3 ">
      <div
        className="w-[100%] min-w-[800px] min-h-[220px] h-auto rounded-[12px] shadow-md flex-col sm:flex-row flex justify-between"
        style={{
          // boxShadow: "0px 4px 9px 0px rgba(152, 160, 180, 0.25)",
          backgroundColor: "#FFF",
        }}
      >
        <div className="flex flex-col md:flex-row lg:flex-row sm:flex-col w-full gap-4">
          <div
            className={`flex flex-col ${
              showAllOrders ? "mt-4" : "mt-[21px]"
            } items-center p-2`}
          >
            <div className="flex flex-col items-center justify-center w-[150px] ">
              <div className="relative flex justify-center w-[62px] h-[62px] mr-4 items-center ml-4 cursor-pointer">
                <div className="relative flex justify-center items-center mb-3">
                  <img
                    src={`/cloud-assets/chim/public/assets/images/profilepictures/${task.patientid}.png`}
                    alt="profile"
                    onError={(e) =>
                      (e.target.src =
                        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                    }
                    className="flex justify-center items-center w-[66px] h-[66px]  border-2 border-[pink] rounded-[14px]  "
                    style={{ border: `2px solid #${task.deductiblemet}` }}
                  />
                </div>
              </div>
           <p className="font-inter font-semibold text-[14px] text-[#101828] pt-1 my-0">

                {task.patient_name}
              </p>
   <p className="text-[#5c5f66] text-[14px] font-inter pt-2 my-0">

                #{task.patientid}
              </p>
              <p className="text-[12px] font-inter text-[#5c5f66] font-normal my-1">
                DOB :{" "}
                {new Date(task.dob).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>

              <div>
                <p className="text-[12px] font-inter text-[#5c5f66] m-0">
                  {(task.insurancename?.length > 22
                    ? `${task.insurancename.slice(0, 10)}...`
                    : task.insurancename) || "No insurance name"}
                </p>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="flex flex-col gap-1 w-full p-2  border-l-[1px] border-[#F3F4F6]">
            {/* Wrapper for Card List with Scroll */}
            <div className="flex flex-col gap-4 overflow-y-auto max-h-[320px] thin-visible-scrollbar ">
              {/* Card Item */}
              <div className="flex flex-column items-center gap-4 mt-2 p-2 justify-between ">
                {task.orders
                  .slice(0, showAllOrders ? task.orders.length : 2)
                  .map((order, index) => {
                    if (
                      (order.ordertype.toLowerCase() === "labs" ||
                        order.ordertype.toLowerCase() === "schedule-rto" ||
                        order.ordertype.toLowerCase() === "procedure") &&
                      !taskscreenprev.some(
                        (item) =>
                          item.toLowerCase() ===
                          normalise(order.ordertype.toLowerCase())
                      )
                    ) {
                      return null; // Skip rendering this order
                    }

                    return (
                      <div
                        key={index}
                       className={`flex relative items-center justify-between gap-4 w-full p-2 border-[1px] rounded-xl pb-1 ${
    String(order?.status).toUpperCase() === "COMPLETED"
      ? "border-[#DCFCE7] bg-white"
      : String(order?.status).toUpperCase() === "CANCELLEDTASK"
      ? "border-[#FECACA] bg-white"
      : "border-[#F9FAFB] bg-white"
  }`}
                      >
                        {(String(order?.status).toUpperCase() === "COMPLETED" ||
  String(order?.status).toUpperCase() === "CANCELLEDTASK") && (
  <div className="absolute inset-0 bg-white opacity-50 rounded-xl pointer-events-none"></div>
)}

                        <div className="flex gap-1 flex-1 items-center">
                          {["COMPLETED", "CANCELLEDTASK"].includes(
                            String(order?.status).toUpperCase()
                          ) && (
                            <div className="mr-1 flex items-center w-[7%]">
                              {String(order?.status).toUpperCase() ===
                                "COMPLETED" && COMPLETEDIcon}
                              {String(order?.status).toUpperCase() ===
                                "CANCELLEDTASK" && CROSSIcon}
                            </div>
                          )}
                          <div className="flex flex-col gap-1 items-start">
                            {
                              <div className="flex items-center justify-center gap-4 ">
                                <div className="font-medium flex items-center text-[13px] text-[#000000]">
                                  <div className="text-[15px]">
                                    {order.ordertype.charAt(0).toUpperCase() +
                                      order.ordertype.slice(1)}
                                  </div>

                                  {!order?.order_notes&&order.ordertype !== "Notes" && (
                                    <button
                                      onClick={() => {
                                        if (
                                          order.status !== "COMPLETED" &&
                                          order.ordertype !== "Notes" &&
                                          order.status !== "CANCELLEDTASK"
                                        ) {
                                          handleScheduleClick(order);
                                        }
                                      }}
                                      className={`ml-2 flex items-center gap-0.5 px-2 py-0.5 rounded-full text-[13px] font-medium cursor-pointer 
    ${
      scheduleStates[order.id] || order?.schedule === "t"
        ? "bg-[#E17954] text-white"
        : "bg-[#D9D9D980] text-[#000000]"
    }`}
                                    >
                                      {/* Show Edit icon only if editable */}
                                      {order.status !== "COMPLETED" &&
                                        order.ordertype !== "Notes" &&
                                        order.status !== "CANCELLEDTASK" && (
                                          <Edit
                                            style={{
                                              width: "10px",
                                              height: "10px",
                                              color:
                                                scheduleStates[order.id] ||
                                                order?.schedule === "t"
                                                  ? "#FFFFFF"
                                                  : "#0E0E0E",
                                            }}
                                          />
                                        )}

                                      <span>
                                        {scheduleStates[order.id] ||
                                        order?.schedule === "t"
                                          ? "Schedule"
                                          : "Today"}
                                      </span>
                                    </button>
                                  )}
                                </div>
                              </div>
                            }
                            <div className="flex flex-col gap-3 font-inter  ">
                              <div className="flex flex-col align-center gap-2">
                                <p className="text-[16px] font-medium text-[#101828] m-0 font-inter text-start">
                                  {order.ordername &&
                                  order.ordername.trim() !== ""
                                    ? order.ordername.replace(/<[^>]*>/g, "") // Remove HTML tags from ordername
                                    : `${order.tov} Level - ${order.lov}`}
                                </p>
                                {/* <p className="text-xs font-light">
                                {order.order_notes}
                              </p> */}
                                <div>
                     {/* {(order.ordertype === "Diagnostic Tests" ||order.ordertype === "Diagnostic test")&& (
  <select
    className="border mt-1 rounded-md px-2 py-[2px] text-[12px] w-[140px]"
    value={order.result || ""}
    disabled={
      String(order.status).toUpperCase() === "COMPLETED" ||
      String(order.status).toUpperCase() === "CANCELLEDTASK"
    }
    onChange={(e) => updateResult(order, e.target.value)}
  >
    <option value="">Select Result</option>
    <option value="Positive">Positive</option>
    <option value="Negative">Negative</option>
    <option value="Inconclusive">Inconclusive</option>
  </select>
)} */}

{["FLU TEST", "STREP TEST", "COVID TEST"].includes(
  order?.ordername?.toUpperCase().replace(/[-_]/g, " ").trim()
) && (
  <select
    className="border mt-1 rounded-md px-2 py-[2px] text-[12px] w-[140px]"
    value={order.result || ""}
    disabled={
      String(order.status).toUpperCase() === "COMPLETED" ||
      String(order.status).toUpperCase() === "CANCELLEDTASK"
    }
    onChange={(e) => updateResult(order, e.target.value)}
  >
    <option value="">Select Result</option>
    <option value="Positive">Positive</option>
    <option value="Negative">Negative</option>
    <option value="Inconclusive">Inconclusive</option>
  </select>
)}

                                </div>
                              </div>
                              {/* <div className="flex w-[350px] gap-1 md:w-[auto] lg:w-[auto] sm:w-[auto] justify-between ">
                              <p className="text-xs text-[#4B4B4B] m-0 font-light">
                                Ordered by: {order?.provider || "-"}
                              </p>
                              <p className="text-xs font-inter text-[#4B4B4B] m-0 font-light">
                                {dayjs(order.ts).format("DD MMMM YYYY")}
                              </p>
                            </div> */}
                            </div>
                          </div>
                        </div>
                        {order?.order_notes ? (
                          <div className="relative bg-[#F9FAFB] flex-1 rounded-[20px] w-[30%] p-3 flex flex-col justify-between">
                            {/* Header */}
                            <div className="flex justify-between items-start mb-2">
                              <h3 className="text-[#973C00] font-semibold font-font1 text-[14px] m-0">
                                NOTES: 
                              </h3>
                              <Edit
                                onClick={() => {
                                  if (
                                    String(order?.status).toUpperCase() !==
                                      "COMPLETED" &&
                                    String(order?.status).toUpperCase() !==
                                      "CANCELLEDTASK"
                                  ) {
                                    openModal(order);
                                  }
                                }}
                                style={{
                                  width: 16,
                                  height: 16,
                                  color: "#979797",
                                  cursor: "pointer",
                                }}
                              />
                            </div>

                            {/* Notes (breakable + scrollable) */}
                            <div
                              className="
          text-[#4B4B4B]  text-start font-light leading-snug font-inter
          whitespace-pre-wrap     text-[16px]                  /* keep line breaks */
          [overflow-wrap:anywhere]                 /* break long words/strings */
          max-h-32 md:max-h-40 overflow-y-auto pr-1 /* scroll if tall */
          thin-visible-scrollbar
        "
                            >
                              {order?.order_notes || ""}
                            </div>

                            {/* Footer (Name) */}
                            <div className="flex justify-end pt-2">
                              <span className="text-[#979797] text-[13px] font-medium font-inter">
                                {order?.completed_by
                                  ? order.completed_by.charAt(0).toUpperCase() +
                                    order.completed_by.slice(1).toLowerCase()
                                  : ""}
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div className="text-[#4A5565] text-[13px] h-[50px] justify-center items-center  font-medium font-inter">                            
                            <p className="text-xs text-[#4B4B4B] m-0 font-light">
                             Ordered by: {" "} {order?.provider||'-'}
                            </p>
                              <p className="text-xs font-inter text-[#4B4B4B] m-0 font-light">
                                 {dayjs(order.ts).format("MM/DD/YYYY hh:mm A")}
                              </p>
                          </div>
                        )}
                        <div className="flex flex-1 justify-center items-center">
                          <div className="flex flex-row justify-end items-center ml-2 gap-2 mb-2">
                            {order.ordertype === "Alerts" && (
                              <button
                                onClick={() =>
                                  handleAlertOpenModal(order.patientid)
                                }
                              >
                                {eyeIcon}
                              </button>
                            )}
                            {order.status !== "CREATED" &&
                            task?.status !== "FLAGGED" &&
                            order?.completed_by ? (
                              <span className="text-[#1D2951] gap-2 text-xs font-inter flex items-center">
                                {userIcon}
                                {order.completed_by.charAt(0).toUpperCase() +
                                  order.completed_by.slice(1).toLowerCase()}
                              </span>
                            ) : (
                              // Step 3: Conditionally render the name or buttons
                              <>
                                {taskscreenprev.includes("Mark Completed") && (
                                  <button
                                    onClick={() => {
                                      handleCompleteClick(order);
                                    }}
                                    className="rounded-[10px] font-inter cursor-pointer flex gap-1 items-center justify-center border-[1px] border-[#16A34A] py-2 px-2 text-[13.5px] bg-[#16A34A33] text-[#16A34A] max-w-[100px] truncate"
                                  >
                                    {completedIcon} Complete
                                  </button>
                                )}
                                {taskscreenprev.includes("Cancel Task") && (
                                  <button
                                    onClick={() => {
                                      handleCancelClick(order);
                                    }}
                                    className="rounded-[10px] font-inter cursor-pointer flex gap-1 items-center justify-center border-[1px] border-[#FFC9C9] py-[9px] px-2 text-[13.5px] bg-[#FEF2F2] text-[#E7000B] max-w-[100px] truncate"
                                  >
                                    {cancelIcon} Cancel
                                  </button>
                                )}
                              </>
                            )}
                          </div>
                          {String(order?.status).toUpperCase() !==
                            "COMPLETED" &&
                            String(order?.status).toUpperCase() !==
                              "CANCELLEDTASK" && (
                              <button
                                type="button"
                                onClick={() =>
                                  markAsFlag([order.id.toString()], order,order.status)
                                }
                                className={`focus:outline-none focus:ring-0 ml-2 focus:ring-offset-0 focus-visible:outline-none 
        ${order.status === "FLAGGED" ? "text-[#E17954]" : "text-gray-500"}
      `}
                              >
                                {flag}
                              </button>
                            )}

                          {!order.order_notes &&
                            String(order?.status).toUpperCase() !==
                              "COMPLETED" &&
                            String(order?.status).toUpperCase() !==
                              "CANCELLEDTASK" && (
                              <div
                                onClick={() => openModal(order)}
                                className="cursor-pointer ml-2 "
                              >
                                {fileIcon}
                              </div>
                            )}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {visibleOrders.length > 1 && (
              <div
                className="cursor-pointer text-xs font-inter text-[#989898] "
                onClick={toggleShowAllOrders}
              >
                {showAllOrders ? "Show Less" : ` View All `}{" "}
                <span
                  className={`inline-flex items-center justify-center ml-2 w-6 h-6 mr-3 rounded-full bg-[#DF6F46]  text-[11px] text-[#fff]`}
                >
                  {pillCount}
                </span>
                {showAllOrders ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {isModalOpen &&
        (modalType === "add" ? (
          <Addnote
            trigger={trigger}
            closeModal={closeModal}
            task={selectedOrder}
          />
        ) : (
          <Updatenote
            trigger={trigger}
            closeModal={closeModal}
            task={selectedOrder}
          />
        ))}
      <ScheduleModal
        open={scheduleConfirmationOpen}
        onClose={closeScheduleConfirmationModal}
        onConfirm={handleconfirmScheduleClick}
        order={selectedOrder}
      />
      {isAlertModal && (
        <Alertsgraphs
          PatientID={selectedAlert}
          isAlert={true}
          onClose={handleAlertCloseModal}
        />
      )}

      <ConfirmDialog
        open={confirmState.open}
        title={confirmState.type === "cancel" ? "Cancel Task" : "Complete Task"}
        description={
          confirmState.type === "cancel"
            ? "Are you sure you want to cancel this task?"
            : "Are you sure you want to mark this task as complete?"
        }
        cancelLabel="Keep Task"
        confirmLabel={
          confirmState.type === "cancel"
            ? "Yes, Cancel Task"
            : "Yes, Complete Task"
        }
        variant={confirmState.type === "cancel" ? "danger" : "success"}
        onConfirm={runConfirmAction}
        onClose={closeConfirm}
      />
    </div>
  );
};

export default FullViewCard;
